import LzMBase from '@lz-models/commons/Base';
import { getFormattedAmount } from 'services/Utils';

export default class SalesInvoiceDetailModel extends LzMBase {

    constructor(model, discountRate, salesTaxRate, furtherTaxRate, isBuyerRegistered) {
        super(model);

        this.discount_rate = +(discountRate || 0);
        this.sales_tax_rate = +(salesTaxRate || 0);
        this.further_tax_rate = +(furtherTaxRate || 0);
        this.is_buyer_registered = !!isBuyerRegistered;

        this.sno = +(model?.sno || 1);
        this.item_id = +(model?.item_id || 0);
        this.item_hs_code = model?.item_hs_code || '';
        this.item_code = model?.item_code || '0000';
        this.item_type_name = model?.item_type_name || '';
        this.item_size_name = model?.item_size_name || '';
        this.item_quality_name = model?.item_quality_name || '';
        this.quantity = +(model?.quantity || 1);
        this.weight = +(model?.weight || 1);
        this.fbr_uom = model?.fbr_uom || '';
        this.price = +(model?.price || 0);
        this.fbr_invoice_no = model?.fbr_invoice_no || '';
    }

    get amount() {
        return +this.quantity * +this.price;
    }
    get amount_fmt() {
        return getFormattedAmount(this.amount, true, true);
    }

    get discount() {
        return +this.amount * +this.discount_rate / 100;
    }
    get discount_fmt() {
        return getFormattedAmount(this.discount, true, true);
    }

    get gross() {
        return +this.amount - +this.discount;
    }
    get gross_fmt() {
        return getFormattedAmount(this.gross, true, true);
    }

    get sales_tax() {
        return +this.gross * +this.sales_tax_rate / 100;
    }
    get sales_tax_fmt() {
        return getFormattedAmount(this.sales_tax, true, true);
    }

    get further_tax() {
        return +this.gross * +this.further_tax_rate / 100;
    }
    get further_tax_fmt() {
        return getFormattedAmount(this.further_tax, true, true);
    }

    get total_tax() {
        return +this.sales_tax + (this.is_buyer_registered ? 0 : +this.further_tax);
    }
    get total_tax_fmt() {
        return getFormattedAmount(this.total_tax, true, true);
    }

    get total() {
        return +this.gross + +this.total_tax;
    }
    get total_fmt() {
        return getFormattedAmount(this.total, true, true);
    }

    static parseArray(data, discountRate, salesTaxRate, furtherTaxRate, isBuyerRegistered) {
        return LzMBase.parseArray(data, SalesInvoiceDetailModel, discountRate, salesTaxRate, furtherTaxRate, isBuyerRegistered);
    }

}
